import { useEffect, useState } from 'react'
import { LayoutGrid, Rows3 } from 'lucide-react'

export type ViewMode = 'cards' | 'rows'

/** Cards ⇄ Rows layout switch (used in every list toolbar). */
export function ViewToggle({ mode, onChange }: { mode: ViewMode; onChange: (m: ViewMode) => void }) {
  return (
    <div className="viewtoggle" role="group" aria-label="Layout">
      <button
        type="button"
        className={`viewtoggle-btn${mode === 'cards' ? ' active' : ''}`}
        onClick={() => onChange('cards')}
        aria-pressed={mode === 'cards'} aria-label="Card layout" title="Cards"
      >
        <LayoutGrid size={15} />
      </button>
      <button
        type="button"
        className={`viewtoggle-btn${mode === 'rows' ? ' active' : ''}`}
        onClick={() => onChange('rows')}
        aria-pressed={mode === 'rows'} aria-label="Row layout" title="Rows"
      >
        <Rows3 size={15} />
      </button>
    </div>
  )
}

/** Per-module layout preference, persisted to localStorage (survives reloads). */
export function useViewMode(key: string, def: ViewMode = 'cards'): [ViewMode, (m: ViewMode) => void] {
  const storeKey = `wpi-crm:view:${key}`
  const [mode, setMode] = useState<ViewMode>(() => {
    try {
      const v = localStorage.getItem(storeKey)
      return v === 'rows' || v === 'cards' ? v : def
    } catch { return def }
  })
  useEffect(() => {
    try { localStorage.setItem(storeKey, mode) } catch { /* ignore */ }
  }, [storeKey, mode])
  return [mode, setMode]
}
